import { render, staticRenderFns } from "./OrderDeliveryPackage.vue?vue&type=template&id=8e77e6fc&"
import script from "./OrderDeliveryPackage.vue?vue&type=script&lang=js&"
export * from "./OrderDeliveryPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports